const ELEMENT_SELECTOR = '[data-immediate-pricing-block]';
const IS_ACTIVE_CLASS  = 'is-active';
const VISIBLE_OPTION_ELEMENT_SELECTOR = '[aria-hidden="false"] [data-immediate-pricing-block-cover-type-option]';
const TITLE_ELEMENT_SELECTOR = '[data-immediate-pricing-block-tabs-title]';
const ANCHOR_SELECTOR = '[data-immediate-pricing-block-tabs-title-anchor]';
const TAB_PANEL_SELECTOR = '[data-immediate-pricing-block-tabs-panel]';

import anime from '@vendor/anime';

function AnimateOutPricingCoverOptions(clickedElement) {
    var elementId = '#' + $(clickedElement).closest(ELEMENT_SELECTOR).attr('id');
    $(elementId).find(TITLE_ELEMENT_SELECTOR).removeClass(IS_ACTIVE_CLASS);
    $(clickedElement).closest(TITLE_ELEMENT_SELECTOR).addClass(IS_ACTIVE_CLASS);
    
    var targets = elementId + ' ' + VISIBLE_OPTION_ELEMENT_SELECTOR;
    anime({
        autoplay: true,
        targets: targets,
        translateY: [0,40],
        translateX: 0,
        translateZ: 0,
        opacity: [1,0],
        easing: "easeOutCubic",
        complete: function() {                    
            AnimateInPricingCoverOptions(clickedElement);
        },
        duration: 300             
    });      
}

function AnimateInPricingCoverOptions(clickedElement) {
    var elementId = '#' + $(clickedElement).closest(ELEMENT_SELECTOR).attr('id');
    var controls = '#' + $(clickedElement).attr('aria-controls');
    var visibleOptionElements = $(elementId).find(VISIBLE_OPTION_ELEMENT_SELECTOR);

    $(visibleOptionElements).removeAttr('style');
    $(elementId).find(TAB_PANEL_SELECTOR).attr('aria-hidden', 'true').removeClass(IS_ACTIVE_CLASS);                    
    $(elementId).find(controls).attr('aria-hidden', 'false').addClass(IS_ACTIVE_CLASS);                    
    $(elementId).find(ANCHOR_SELECTOR).attr('aria-selected', 'false');
    $(clickedElement).attr('aria-selected', 'true');    

    visibleOptionElements = $(elementId).find(VISIBLE_OPTION_ELEMENT_SELECTOR);
    $(visibleOptionElements).attr('style', 'opacity:0');

    for (var i=0;i<$(visibleOptionElements).length; i++) {    
        var targ = $(visibleOptionElements)[i];  
        var delay = i ==0 ? 0 : 200;                     
        anime({
            autoplay: true,
            delay: delay,
            targets: targ,
            translateY: [40,0],
            translateX: 0,
            translateZ: 0,
            opacity: [0,1],
            easing: "easeOutCubic",
            duration: 500,
            complete: function() {
                $(visibleOptionElements).removeAttr('style'); 
            } 
        }); 
    }
}

export default function exec () {
	if ($(ELEMENT_SELECTOR).length) {
        $(ELEMENT_SELECTOR).find(ANCHOR_SELECTOR).on('click', function(e) {
            AnimateOutPricingCoverOptions(this);
	    });
    }
}


// WEBPACK FOOTER //
// ./project/client/src/core/modules/immediate-cover-types-block/index.js